import { useNavigate } from 'react-router-dom';

import { MaintenancePage } from '@phx/maintenance';
import { UnderMaintenanceIllustration } from '@phx/myphx-lib';

import { useAppMaintenanceStatus } from '../../hooks/use-app-maintenance-status';
import { routes } from '../router/routes';

export const Maintenance = () => {
    const maintenanceStatus = useAppMaintenanceStatus();
    const navigate = useNavigate();

    const handleContactSupport = () => {
        navigate(routes.support);
    };

    return (
        <MaintenancePage
            maintenanceStatus={maintenanceStatus}
            logo={{
                src: '/static/img/lilly-logo.svg',
                alt: 'LillyDirect',
                width: 'auto',
                height: '35px',
            }}
            illustration={<UnderMaintenanceIllustration />}
            onContactSupport={handleContactSupport}
        />
    );
};
